module.exports = __webpack_public_path__ + "static/img/18.571883f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/18.jpg
// module id = dL1M
// module chunks = 5